import { MdCheck } from "react-icons/md";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Spin, message, Tooltip } from "antd";
import Button from "../../Button";
import { apiPayment } from "../../../services/payment";
import CreditCardStep, { ETypePurchase } from "./CreditCardStep";
import { IClient, useClients } from "../../../contexts/ClientsContext";
import { CardButton } from "./styles";
import Cards from "react-credit-cards";
import api from "../../../services/api";
import { useAuth } from "../../../contexts/AuthContext";
import { PixStep } from "./PixStep";
import { PaymentLink } from "./PaymentLink";

interface PaymentModalProps {
  show: boolean;
  onCancel?: () => void;
  paymentData: any;
  callDarf: any;
  hideDarfDownload?: boolean;
  onSucessPix?: (event: any) => void;
  onSucessCreditCard?: (event?: any) => void;
  planCurrent?: any;
  disablePixOption?: boolean;
  disableCreditCardOption?: boolean;
  disableCreditCardMessage?: string;
  customInstallments?: number;
  maxPixValue?: number;
  maxCCValue?: number;
  selectedYear?: number;
  emitting?: boolean;
  clientSelected?: IClient;
  createConciergePlan: React.MouseEventHandler<Element>;
  typeConcierge?: string;
  filters?: any;
  disablePaymentLinkOption?: boolean;
  onlyInvoiceOption?: boolean;
}

export interface cardAttributes {
  id: string;
  first_six_digits: string;
  last_four_digits: string;
  brand: string;
  customer_id: string;
  holder_name: string;
  exp_month: number;
  exp_year: number;
  status: string;
  type: string;
  created_at: Date;
  updated_at: Date;
  billing_address: {
    street: string;
    zip_code: string;
    city: string;
    state: string;
    country: string;
    line_1: string;
  };
}

export interface ICreatePaymentXPPro {
  cardInfo?:
    | {
        line_1: any;
        zip_code: any;
        city: any;
        state: any;
        holder_name: any;
        number: any;
        exp_month: any;
        exp_year: any;
        holderDocument: any;
        cvv: any;
      }
    | { card_id: string };
  clientInfo:
    | {
        name: any;
        email: any;
        document: any;
        phone?: any;
        isAssessor: boolean;
      }
    | {
        customer_id: string;
        document: string;
        isAssessor: boolean;
        email: string;
      };
  paymentForm?: string;
  installments?: number;
}

interface PaymentInfoContentProps {
  content: JSX.Element;
  title?: string;
  amount?: number;
}

export interface PaymentDetailsProp {
  value?: number;
  paymentId: string;
  qrCodeLink?: string;
  name?: string;
}

enum EPlanStep {
  CHOOSE_PAYMENT = "CHOOSE_PAYMENT",
  PIX_PAYMENT = "PIX_PAYMENT",
  CC_PAYMENT = "CC_PAYMENT",
  PAYMENT_LINK= "PAYMENT_LINK",
  LOADING = "LOADING",
  FINISHED = "FINISHED",
}

let getStatus: any;

export const PaymentModal: React.FC<PaymentModalProps> = ({
  show,
  onCancel,
  paymentData,
  callDarf,
  hideDarfDownload,
  disableCreditCardOption,
  disableCreditCardMessage,
  onSucessPix,
  planCurrent,
  onSucessCreditCard,
  customInstallments,
  maxPixValue,
  selectedYear,
  emitting = false,
  clientSelected,
  createConciergePlan,
  typeConcierge,
  filters,
  disablePaymentLinkOption = false,
  onlyInvoiceOption = false
}) => {
  const { user } = useAuth();
  const { selectedClient, getClients, setSelectedClient } = useClients();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState<EPlanStep>(EPlanStep.CHOOSE_PAYMENT);
  const [cardList, setCardList] = useState<cardAttributes[]>();
  const [disabledConciergeOption] = useState(
    user.user.liberadaContratacao && !user.user.isManager && !user.user.office
  );

  const ocultaContratacaoViaFatura = paymentData.planUpgrade
  const desabilitaContratacaoViaPix = !!paymentData.planUpgrade
  const desabilitaContratacaoViaLink = !!paymentData.planUpgrade

  useEffect(() => {
    const token = localStorage.getItem("@VeloTax:token");
    if (!token) message.error("Token não encontrado. Recarregue sua página");
    else if (
      !cardList &&
      step === EPlanStep.CHOOSE_PAYMENT &&
      !disableCreditCardOption
    ) {
      setLoading(true);
      apiPayment
        .get("/pro/list-card", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setCardList(res?.data?.list || []);
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, [step, cardList, disableCreditCardOption]);

  const createPlanXPPro = (data: ICreatePaymentXPPro) => {
    const body = {
      clientUsername: clientSelected?.username,
      type: planCurrent?.type,
      from: "VELOPRIME",
      planUpgrade: paymentData.planUpgrade || false,
      isPlan: true,
      acceptTerms: true,
      ...data,
    };
    setLoading(true);
    setStep(EPlanStep.LOADING);
    api
      .post("/plans/createPayment", body)
      .then(async (res) => {
        if (res.data.payed) {
          setStep(EPlanStep.FINISHED);
          const { clients } = await getClients({...(filters || {})});
          const client = selectedClient;
          const newClient = clients.find((c: any) => c.username === client?.username);
          setSelectedClient(null);
          setTimeout(() => {
            setSelectedClient(newClient);
            onSucessCreditCard && onSucessCreditCard()
          }, 200);
        } else {
          message.info(
            "Seu pagamento ainda não foi processado. Tente novamente mais tarde."
          );
          setStep(EPlanStep.CHOOSE_PAYMENT);
          if (onCancel) onCancel();
        }
      })
      .catch(() => {
        message.error("Algo deu errado. Tente novamente mais tarde.");
        setStep(EPlanStep.CHOOSE_PAYMENT);
      })
      .finally(async () => setLoading(false));
  };

  const getPurchaseType = () => {
    if (planCurrent?.type in ETypePurchase) return planCurrent?.type;

    return ETypePurchase.UNIQUE;
  };

  const plansContentDisplay: Record<EPlanStep, PaymentInfoContentProps> = {
    [EPlanStep.CHOOSE_PAYMENT]: {
      content: (
        <Spin spinning={emitting}>
          <Row gutter={[16, 8]}>
            {!ocultaContratacaoViaFatura && <Col span={24}>
              <Tooltip
                title={
                  disabledConciergeOption
                    ? "Você precisa ter permissões de gerente para contratar usando o plano concierge"
                    : ""
                }
              >
                <Button
                  block
                  size="large"
                  type="primary"
                  style={{
                    fontWeight: 500,
                    backgroundColor: disabledConciergeOption
                      ? "var(--ghost)"
                      : "",
                    border: disabledConciergeOption ? "none" : "",
                    cursor: disabledConciergeOption ? "default" : "pointer",
                  }}
                  onClick={(e) => {
                    if (!user.user.liberadaContratacao) {
                      window.location.href = 'mailto:parcerias@velotax.com.br';
                    } else if (disabledConciergeOption) {
                    } else createConciergePlan(e);
                  }}
                >
                  {user.user.liberadaContratacao
                    ? "INCLUIR NA FATURA DO ESCRITÓRIO"
                    : "ATIVAR MEU CONCIERGE VELOTAX"}
                </Button>
              </Tooltip>
            </Col>}
            <Col span={24}>
              <Tooltip title={disableCreditCardMessage}>
                <Button
                  block
                  size="large"
                  type="primary"
                  onClick={() => {
                    if (!disableCreditCardOption && !onlyInvoiceOption) setStep(EPlanStep.CC_PAYMENT);
                  }}
                  style={{
                    fontWeight: 500,
                    backgroundColor: (disableCreditCardOption || onlyInvoiceOption)
                      ? "var(--ghost)"
                      : "",
                    border: (disableCreditCardOption || onlyInvoiceOption) ? "none" : "",
                    cursor: (disableCreditCardOption || onlyInvoiceOption) ? "default" : "pointer",
                  }}
                  disabled={onlyInvoiceOption}
                >
                  {(cardList || []).length > 0 && `ADICIONAR `}CARTÃO DE CRÉDITO
                </Button>
              </Tooltip>
            </Col>
            <Col span={24}>
                <Button
                  block
                  size="large"
                  type="primary"
                  style={{
                    fontWeight: 500,
                    backgroundColor: (typeConcierge === 'mensal' || onlyInvoiceOption)
                      ? "var(--ghost)"
                      : "",
                    border: (typeConcierge === 'mensal' || onlyInvoiceOption) ? "none" : "",
                    cursor: (typeConcierge === 'mensal' || onlyInvoiceOption) ? "default" : "pointer",
                  }}
                  disabled={desabilitaContratacaoViaPix || onlyInvoiceOption}
                  onClick={(e) => {
                    if (!disableCreditCardOption && !onlyInvoiceOption) setStep(EPlanStep.PIX_PAYMENT);
                  }}
                >
                  PIX À VISTA
                </Button>
            </Col>
            <Col span={24}>
                <Button
                  block
                  size="large"
                  type="primary"
                  style={{
                    fontWeight: 500,
                    backgroundColor: (typeConcierge === 'mensal' || onlyInvoiceOption)
                      ? "var(--ghost)"
                      : "",
                    border: (typeConcierge === 'mensal' || onlyInvoiceOption) ? "none" : "",
                    cursor: (typeConcierge === 'mensal' || onlyInvoiceOption) ? "default" : "pointer",
                  }}
                  disabled={desabilitaContratacaoViaLink || onlyInvoiceOption}
                  onClick={(e) => {
                    if (!disableCreditCardOption && !onlyInvoiceOption) setStep(EPlanStep.PAYMENT_LINK);
                  }}
                >
                  LINK DE PAGAMENTO
                </Button>
            </Col>
            {!onlyInvoiceOption && <Col span={24}>
              <Row gutter={[8, 8]}>
                {loading || true ? (
                  <Col span={24}>
                    <Row justify="center" style={{ margin: "4px 0 -30px" }}>
                      <Spin spinning={loading}></Spin>
                    </Row>
                  </Col>
                ) : (
                  (cardList || []).map((card) => {
                    return (
                      <Col span={24} key={card.id}>
                        <CardButton
                          className="full-width"
                          onClick={() => {
                            createPlanXPPro({
                              cardInfo: { card_id: card?.id },
                              clientInfo: {
                                customer_id: card?.customer_id,
                                document: user?.user?.username,
                                isAssessor: true,
                                email: user?.user?.email,
                              },
                            });
                          }}
                        >
                          <Row
                            style={{ width: "100%", paddingRight: "1rem" }}
                            align="middle"
                            justify="space-between"
                          >
                            <Col>
                              {(Cards as any)({
                                preview: true,
                                cvc: "***",
                                name: "",
                                expiry: "",
                                number:
                                  card.first_six_digits +
                                  "** *****" +
                                  card.last_four_digits
                              })}
                            </Col>
                            <Col>
                              {"**** **** **** " + card.last_four_digits}
                            </Col>
                          </Row>
                        </CardButton>
                      </Col>
                    );
                  })
                )}
              </Row>
            </Col>}
          </Row>
        </Spin>
      ),
      title: "Escolha sua forma de pagamento:",
    },
    [EPlanStep.PIX_PAYMENT]: {
      content: (
        <PixStep
          plan={planCurrent}
          paymentData={paymentData}
          onSucess={onSucessPix}
          backStep={() => setStep(EPlanStep.CHOOSE_PAYMENT)}
          clientUsername={clientSelected?.username}
          type={planCurrent?.type}
          onCancel={onCancel}
          setStep={setStep}
          filters={filters}
        />
      ),
      title: "PIX À VISTA",
    },
    [EPlanStep.PAYMENT_LINK]: {
      content: (
        <PaymentLink backStep={() => setStep(EPlanStep.CHOOSE_PAYMENT)} paymentData={paymentData}/>
      ),
      title: "LINK DE PAGAMENTO",
    },
    [EPlanStep.CC_PAYMENT]: {
      content: (
        <CreditCardStep
          initialized={true}
          typePurchase={getPurchaseType()}
          handleClosableModal={() => {}}
          status=""
          plan={planCurrent}
          handleSuccess={onSucessCreditCard}
          setInitialized={() => {}}
          darfData={paymentData}
          customInstallments={customInstallments}
          backToRoot={() => setStep(EPlanStep.CHOOSE_PAYMENT)}
          clientSelected={clientSelected}
          createPlanXPPro={createPlanXPPro}
        />
      ),
      title: "Cartão de crédito",
    },
    [EPlanStep.LOADING]: {
      content: (
        <Row>
          <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "15px",
            }}
          >
            <Spin spinning={loading}></Spin>
            <span style={{ marginLeft: "10px" }}>
              Estamos processando o seu pagamento...
            </span>
          </Col>
        </Row>
      ),
      title: "Aguarde um instante",
    },
    [EPlanStep.FINISHED]: {
      content: (
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <MdCheck color={"var(--ant-success-color)"} size={120} />
          </Col>
          <span
            style={{
              marginTop: "10px",
              fontSize: "16px",
              textAlign: "center",
              marginBottom: "35px",
              fontWeight: "500",
              width: "100%",
            }}
          >
            Seu pagamento foi realizado com sucesso
          </span>
        </Row>
      ),
      title: "Confirmação de Pagamento",
    },
  };

  const title = plansContentDisplay?.[step]?.title;
  const content = plansContentDisplay?.[step]?.content;

  const cancelActions = (e: any) => {
    setStep(EPlanStep.CHOOSE_PAYMENT);
    clearInterval(getStatus);

    if (onCancel) {
      onCancel();
    }
  };

  const handlePadding =
    window.innerWidth <= 768 ? "0 32px 32px" : "0 64px 32px";

  return (
    <Modal
      open={show}
      width={580}
      title={title}
      footer={null}
      keyboard={false}
      maskClosable={false}
      className="paymentModal"
      onCancel={(e) => cancelActions(e)}
      bodyStyle={{ padding: handlePadding }}
    >
      {content}
    </Modal>
  );
};
